<template>
  <div v-if="!this.$route.meta.hideNavigation">
    <v-app-bar class="online_course_navbar" fixed elevate-on-scroll>
      <div class="online_course_brand">
        <v-toolbar-title class="online_course_logo" @click="goToHome" >
          <img src="@/assets/images/sajilo-class.png" />
        </v-toolbar-title>
      </div>

      <div class="dropdown_menu nav_show">
        <!-- <v-select
          solo   
          dense
          :items="categories"
          label="Categories"
          item-text="name"
          item-value="name"
          v-model="search.categories"
          @change="getSearch"
          >

          </v-select> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="categories-btn" text v-on="on">Categories
              <v-icon
                right
                dark
              >
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          
          <v-list>
            <v-list-item class="nav_dropdown_menu" v-for="(category, index) in categories" :key="index" @click="getCategoryCourses(category.id, category.name)">
              <v-list-item-title class="dropdown_menu">
                {{category.name}}
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item>
              <v-list-item-title class="dropdown_menu">Single Course</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </div>

      <div class="search_bar">
        <form @submit.prevent="getSearch(query, result)">
          <input type="text" v-model="search.search" class="form-control" placeholder="What do you want to learn ?" />
          <div class="search_btn" @click.prevent="getSearch()">
            <v-icon>mdi-magnify</v-icon>
          </div>
        </form>
      </div>

      <v-spacer></v-spacer>
      <div class="d-flex" v-if="!user">
        <!-- <v-btn icon class="cart_btn" @click="goToCart" >
          <v-icon>mdi-cart</v-icon>
        </v-btn> -->
        <button type="button" class="blue_outline_button mr-4" @click="$router.push('/login')" >Sign in</button>

        <!-- <v-btn text class="login_btn nav_show"  @click.stop="dialog = true">Log In</v-btn>
        <v-dialog v-model="dialog" max-width="400px" overlay-opacity="0.7">
          <Auth></Auth>
        </v-dialog> -->
        <button type="button" class="blue_button nav_show" @click="$router.push('/register')" >Join For Free</button>
      </div>

      <div class="d-flex" v-else>
        <button type="button" class="blue_button_link" @click="goToMyCourse(), $bus.emit('loading-toggle')">My Courses</button>
        <div class="dropdown_menu nav_show">
          <v-menu 
            offset-y  
            :nudge-width="200"
            min-width="150px"
            origin="top center"
            content-class="account-menu"
            transition="scale-transition"
            bottom
            
          >
            <template v-slot:activator="{ on, attrs }">
              
                <figure class="sajilo__useravatar" v-on="on" v-bind="attrs">
                  <img :src="user.profile_pic" v-if="user.profile_pic" />
                  <img :src="`https://fakeimg.pl/350x200/?text=${user.first_name}`" v-else />
                </figure>
              <!-- <v-toolbar-title v-on="on"> -->
                <!-- <i class="fa fa-angle-down"></i> -->
              <!-- </v-toolbar-title> -->
            </template>

            <v-list class="dropdown_list account-list">
              <v-list-item class="user_info">
                <v-list-item-title>
                  <span class="navbar-fullname d-block mb-1">{{ user.full_name }}</span>
                  <span class="navbar-email d-block "><v-icon small class="mr-1">mdi-email</v-icon>{{ user.email }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="nav_dropdown_menu" @click="goToProfile()">
                <v-icon class="mr-2">mdi-account-circle</v-icon>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item class="nav_dropdown_menu" @click="logout">
                <v-icon class="mr-2">mdi-power</v-icon>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
      search:{
          search:'',
          // categories:'',
      },
      categories: [],
      catId: null,
      catName: null,
      query: '',
      result: null,
      user: JSON.parse(localStorage.getItem('user')),
    }
  },
  created () {
    this.$store.dispatch('getCategories').then(res => {
      this.categories = res
    })
  },
  computed: {
    authentication () {
      const user = JSON.parse(localStorage.getItem('user'))
      return !!(user && Object.keys(user).length > 0 && this.$route.meta.authentication)
    }
  },
  async mounted() {
    
  },
  methods: {
    logout () {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      this.$router.push('/')
      this.$bus.emit('loading-toggle');
      window.location.reload()
    },
    async getCategoryCourses(categoryId, categoryName) {
      let category= {
        category:categoryId,
      }
      this.$bus.emit('loading-toggle')
      await this.$api.getWithPayload('/course/paginated/',category).then(res => {
        this.catId = categoryId;
        this.catName = categoryName;
        this.result= res.results;
        
        if(this.result.length === 0) {
          this.$router.push('/page-not-found')
        }
        else {
          this.$router.push(`/course/?category=${categoryId}&categoryName=${categoryName}`)
          this.$bus.emit('category-result', this.result);
        }
      })
      // location.reload();
      this.$bus.emit('loading-toggle')
    },
    async getSearch() {
      this.$bus.emit('loading-toggle')
      this.$router.push({ name: 'search', query: this.search })
      await this.$api.getWithPayload('/course/paginated/',this.search).then(res => {
        this.result= res.results;
        this.$bus.emit('search-result', this.result);
      })
      this.$bus.emit('loading-toggle')
      this.search.search = ''
      
      // this.$router.push(`/search/?search=${query}`)
      // this.searchName = `${query}`;
      // location.reload();
    },
    goToHome() {
      this.$router.push('/')
    },
    goToMyCourse() {
      this.$router.push('/mycourses')
    },
    goToCart() {
      this.$router.push('/cart')
    },
    goToProfile() {
      this.$router.push('/profile')
    },
  }
}
</script>

<style>
.online_course_navbar {
  box-shadow: none !important;
  border-bottom: 1px solid #efefef !important;
  background: #fff !important;
  height: auto !important;
}
.account-list .nav_dropdown_menu > *, .navbar-fullname, .navbar-email, .navbar-email .v-icon {
  /* color: rgba(14, 161, 223, 0.5) !important; */
  color: var(--color-primary) !important;
}
.account-list .nav_dropdown_menu > * {
  font-family: var(--font-poppins);
  font-size: 14px;
}
.navbar-fullname {
  font-weight: 500 !important;
  font-size: 16px !important;
}
.navbar-email {
  font-size: 13px !important;
}
.v-list .nav_dropdown_menu > * {
  line-height: 1.3 !important;
}
.online_course_navbar.v-app-bar--hide-shadow {
  border-bottom: none !important;
}
.account-menu.v-menu__content {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.14) !important;
  margin-top: 10px;
  overflow: visible !important;
  contain: none !important;
}
.v-menu__content.account-menu:before {
  content: '';
  position: absolute;
  top: -8px;
  left: 65%;
  z-index: 1;
  transform: translateX(-65%);
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent transparent var(--color-primary) transparent;
  border-width: 0 10px 10px 10px !important;
}
.v-app-bar.v-app-bar--fixed{
  z-index: 200 !important;
}
.online_course_navbar .v-toolbar__content {
  padding: 4px 24px;
  height: auto !important;
}
.online_course_navbar.v-app-bar--hide-shadow .v-toolbar__content {
  padding: 25px 24px;
}
.online_course_brand {
  padding-right: 20px;
}
.online_course_logo {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.online_course_logo img {
  width: 160px;
}
.dropdown_menu {
  padding-right: 20px;
}
.search_bar {
  flex: 1 1 auto;
  max-width: 100%;
  display: flex;
}
.search_bar form {
  flex: 1 1 auto;
  max-width: 100%;
  display: flex;
}
.search_bar form input {
  border: 1px solid #efefef;
  padding: 5px 10px;
  flex: 1 1 auto;
  max-width: 100%;
  min-width: 0;
  border-radius: 4px 0 0 4px;
  background-color: var(--color-input);
}
.search_btn {
  padding: 5px 10px !important;
  cursor: pointer;
}
.search_bar .search_btn {
  background-color: var(--color-primary) !important;
  border-radius: 0 4px 4px 0;
}
.search_btn i {
  color: #fff !important;
}
.login_btn {
  margin-right: 1rem;
}
.dropdown_menu{
  cursor: pointer;
}
.cart_btn .v-icon{
  height: 20px !important;
  font-size: 20px !important;
  width: 20px !important;
}
.categories-btn {
  text-transform: capitalize !important;
  font-family: var(--font-poppins);
}
.categories-btn.v-btn {
  color: var(--color-dark) !important;
}

@media (min-width: 1904px) {
  .online_course_navbar .v-toolbar__content {
    max-width: 1785px;
    margin: auto;
  }
}
@media screen and (min-width: 768px) {
  .nav_icon {
    display: none !important;
  }
}
@media screen and (max-width: 768px) {
  .nav_show {
    display: none !important;
  }
  .search_bar {
    display: block !important;
  }
}
</style>
